<template>
  <!-- pc登录 -->
  <div class="login-wrap">
    <!-- <RemoteScript src="./jquery.min.js"></RemoteScript> -->
    <div class="login-bg"></div>
    <div class="login-form">
      <p class="login-title">登录</p>
      <div class="login-content">
        <div class="login-tab">
          <div class="login-tab-item login-tab-stu">学生</div>
          <div class="login-tab-item login-tab-tea" @click="goTeaLogin">教师</div>
        </div>
        <el-form :model="userForm" :rules="userRule" ref="userForm">
          <div class="form-title">用户名</div>
          <el-form-item prop="userName">
            <el-input name="userName" v-model="userForm.userName" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <div class="form-title">密码</div>
          <el-form-item prop="password">
            <el-input name="password" type="password" v-model="userForm.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <div v-if="verifyCode">
            <div class="form-title">验证码</div>
            <el-form-item prop="verify">
              <div class="verify-code-item">
                <el-input name="verifyCode" v-model="userForm.verify" placeholder="请输入验证码"></el-input>
                <div class="verify-code">{{verifyCode}}</div>
              </div>
              <p v-if="showVerifyCode" class="verify-code-tips">请输入验证码</p>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button @click="goLogin('userForm')">登录</el-button>
          </el-form-item>
        </el-form>
        <div class="other-btns">
          <!-- <a @click="goRegister">注册账号</a>
          <span>｜</span> -->
          <a href="http://web.etiantian.com/ett20/study/common/index1.jsp" target="_blank">忘记密码</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userForm: {
        userName: '',
        password: '',
        verify: ''
      },
      userRule: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      verifyCode: '', // 验证码
      showVerifyCode: false,
      // webhost: '//web.etiantian.com'
      webhost: 'https://gw1-bj.etiantian.net:15280'
    }
  },
  created() {
    this.getWebUrl()
  },
  methods: {
    goLogin(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let param = {
            userName: this.userForm.userName,
            password: this.userForm.password,
            userType: 3 // 学生登录 userType为3
          }
          if (this.verifyCode) {
            if (!this.userForm.verify) {
              this.showVerifyCode = true
              return
            } else {
              this.showVerifyCode = false
              param.verifyCode = this.userForm.verify
            }
          }
          let loginUrl = `${this.$etturl}home/checkUserName.do?callback=?`
          $.ajax({
            type: 'post',
            url: loginUrl,
            cache: false,
            async: false,
            dataType: 'jsonp',
            jsonp: "jsoncallback",
            data: param,
            success: (res) => {
              if (res.result != 1) {
                this.$toast.center('用户名或密码错误')
                this.verifyCode = res.data.verifyCode
                this.userForm.verify = ''
              } else {
                let url = this.webhost + "/ett20/study/common/login.jsp"
                document.forms[0].setAttribute('action', url)
                document.forms[0].setAttribute('method', 'post')
                document.forms[0].setAttribute('target', '_self')
                document.forms[0].setAttribute('accept-charset', 'gbk')
                document.forms[0].submit()
                // let url = this.webhost + "/ett20/study/common/login.jsp"
                // window.location.href = url
              }
            }
          })
        }
      })
    },
    goRegister() {
      let url = this.$router.resolve({
        path: '/register'
      })
      window.open(url.href, '_blank')
    },
    goTeaLogin() {
      window.open('https://school-web.etiantian.com/elogin/#/', '_blank')
    },
    getWebUrl() {
      //web地址
      let webhost = '//web.etiantian.com'
      let currhost = window.location.host
      if (currhost.match(/(www\.etiantian\.net)$/g)) {
          webhost = '//web.etiantian.net'
      } else if (currhost.match(/(\.crtc\.etiantian\.com)$/g)) {
          webhost = '//web.crtc.etiantian.com'
      } else if (currhost.match(/(www2\.etiantian\.net)$/g)) {
          webhost = '//web2.etiantian.net'
      } else if (currhost.match(/(\.etiantian\.net)$/g)) {
          webhost = '//web.etiantian.net'
      } else if (currhost.match(/(\.etiantian\.com)$/g)) {
          webhost = '//web.etiantian.com'
      }
      this.webhost = webhost
    }
  }
}
</script>
<style lang="scss" scoped>
.login-wrap {
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex;
  min-width: 1200px;
  min-height: 750px;
  font: 14px/1.5 "Microsoft Yahei", tahoma, Srial, helvetica, sans-serif;
  .login-bg {
    width: 50%;
    min-width: 600px;
    height: 100%;
    flex-shrink: 0;
    background: url('../../assets/images/login/bg.png') no-repeat;
    background-position: center;
    background-size: cover;
  }
  .login-form {
    min-width: 600px;
    height: 100%;
    padding-left: 140px;
    padding-top: 110px;
    .login-title {
      display: inline-block;
      font-size:48px;
      font-weight:bold;
      color:rgba(33,124,254,1);
      line-height: 30px;
      border-bottom: 14px solid rgba(255,129,86,1);
    }
    .login-content {
      width: 450px;
      margin-top: 150px;
      .login-tab {
        display: flex;
        width: 100%;
        font-size: 18px;
        &-item {
          width: 50%;
          height: 50px;
          text-align: center;
          line-height: 50px;
          cursor: pointer;
          font-weight: 500;
        }
        &-stu {
          padding-bottom: 16px;
          color: #4aacee;
          border-bottom: 3px solid #4aacee;
        }
        &-tea {
          padding-bottom: 16px;
          color: #333;
          border-bottom: 1px solid #ccc;
        }
        &-tea:hover {
          color: #4aacee;
        }
      }
      .form-title {
        font-size: 16px;
        color: #222;
        padding: 30px 0 15px;
      }
      .verify-code-item {
        display: flex;
      }
      .verify-code {
        flex-shrink: 0;
        width: 170px;
        height: 62px;
        line-height: 62px;
        text-align: center;
        font-size: 18px;
        border: 1px solid rgba(213, 213, 213, 1);
        border-left: 0;
        border-radius: 0 10px 10px 0;
        letter-spacing: 3px;
        font-weight: bolder;
        font-family: Arial;
      }
      .verify-code-tips {
        color: #F56C6C;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
      }
      .other-btns {
        text-align: center;
        font-size: 14px;
        color: #4f4f4f;
        line-height: 33px;
        margin-top: 40px;
        a {
          color: #7E7E7E;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.login-form {
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__content {
    line-height: 62px;
    .el-input__inner {
      width: 100%;
      height: 62px;
      line-height: 62px;
      background: rgb(232, 240, 254);
      border: 1px solid rgba(213,213,213,1);
      border-radius: 10px;
      padding: 0 15px;
      font-weight: bold;
    }
  }
  .verify-code-item {
    .el-input__inner {
      border-radius: 10px 0 0 10px;
    }
  }
  .el-button {
    display: block;
    width: 260px;
    height: 72px;
    line-height: 72px;
    background: #ff8156;
    box-shadow: 0px 11px 21px 0px rgba(255, 86, 129, 0.35);
    border-radius: 36px;
    font-size: 18px;
    color: rgba(255,255,255,1);
    text-align: center;
    padding: 0;
    margin: 0 auto;
    margin-top: 35px;
  }
  .el-button:active {
    border-color: #ff8156;
  }
}
</style>